// components/Hero.js
import React from 'react';
import './Hero.css';
import TechGlobe from './TechGlobe';

import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="hero-container">
      <div className="hero-content">
        <h1 className={'white'}>{t('hero.title')}</h1>
        <p>
          {t('hero.description')}
        </p>
        <div className="hero-buttons">
          <button className="btn" onClick={() => scrollToSection('products')}>{t('hero.solutionsBtn')}</button>
          <button className="btn btn-outline" onClick={() => scrollToSection('contact')}>{t('hero.contactBtn')}</button>
        </div>
      </div>
      <div className="hero-globe">
        <TechGlobe />
      </div>
    </div>
  );
};

export default Hero;